export const CREATE_EP_TEMPLATE = 'CREATE_EP_TEMPLATE'

export const UPDATE_EP_TEMPLATE = 'UPDATE_EP_TEMPLATE'
